import * as Route from '../utils/serverRoutes';
import {
  transformResponseCollection,
  updateCollectionById,
  payloadToData,
} from '../utils/helpers';
import makeRequest, { uploadFile } from '../utils/makeRequest';

const customerSegment = {
  state: {
    collection: [],
    uploading: false,
    uploadingImage: false,
  },
  reducers: {
    fetchCustomerSegmentsReducer(state, { collection }) {
      return { ...state, collection };
    },
    addCustomerSegmentReducer(state, payload) {
      return { ...state, collection: [...state.collection, payload] };
    },
    updateCustomerSegmentReducer(state, payload) {
      return {
        ...state,
        collection: updateCollectionById(state.collection, payload.id, payload),
      };
    },
    removeCustomerSegmentReducer(state, { id }) {
      const collection = state.collection.filter((e) => e.id !== id);

      return { ...state, collection };
    },
    updateAttributeReducer(state, payload) {
      return { ...state, ...payload };
    },
  },
  effects: (dispatch) => ({
    async fetchCustomerSegments(bmcId) {
      dispatch.customerSegment.updateAttributeReducer({ uploading: true });

      makeRequest({
        dispatch,
        url: Route.customerSegments(bmcId),
        success: (response) => {
          dispatch.customerSegment.fetchCustomerSegmentsReducer({
            collection: transformResponseCollection(response.data.data),
          });
        },
        finish: () => {
          dispatch.customerSegment.updateAttributeReducer({ uploading: false });
        },
      });
    },
    async addCustomerSegment(_, state) {
      makeRequest({
        dispatch,
        method: 'post',
        url: Route.customerSegments(state.bmc.current.id),
        success: () => {
          dispatch.customerSegment.reloadCustomerSegment(state.bmc.current.id);
        },
      });
    },
    async updateCustomerSegment(payload, state) {
      const data = payloadToData(payload);
      dispatch.customerSegment.updateCustomerSegmentReducer(data);

      makeRequest({
        dispatch,
        method: 'put',
        url: Route.customerSegment(state.bmc.current.id, payload.id),
        data: { customerSegment: data },
        success: payload.success,
        finish: payload.finish,
      });
    },
    async updateCustomerSegmentImage(payload, state) {
      const { id, name, blob, success } = payload;

      dispatch.customerSegment.updateAttributeReducer({
        uploadingImage: id,
      });

      uploadFile({
        url: Route.customerSegment(state.bmc.current.id, id),
        modelName: 'customer_segment',
        name,
        blob,
        dispatch,
        success: (res) => {
          dispatch.customerSegment.updateCustomerSegmentReducer({
            id,
            [name]: res.data.data.attributes[name],
          });

          if (success) success();
        },
        finish: () => {
          dispatch.customerSegment.updateAttributeReducer({
            uploadingImage: false,
          });
        },
      });
    },
    updateCustomerSegmentImageCoords({
      id,
      coords,
      croppedAreaPixels,
      innerCropData,
      zoom,
    }) {
      const name = 'imageCoords';
      const value = {
        ...coords,
        ...croppedAreaPixels,
        cropperData: { ...innerCropData, zoom },
      };

      dispatch.customerSegment.updateAttributeReducer({
        uploadingImage: id,
      });

      dispatch.customerSegment.updateCustomerSegment({
        id,
        name,
        value,
        success: (res) => {
          dispatch.customerSegment.updateCustomerSegmentReducer({
            id,
            [name]: res.data.data.attributes[name],
          });

          dispatch.customerSegment.updateCustomerSegmentReducer({
            id,
            image: res.data.data.attributes.image,
          });
        },
        finish: () => {
          dispatch.customerSegment.updateAttributeReducer({
            uploadingImage: false,
          });
        },
      });
    },
    async removeCustomerSegment(payload, state) {
      makeRequest({
        dispatch,
        method: 'delete',
        url: Route.customerSegment(state.bmc.current.id, payload.id),
        success: () => {
          dispatch.customerSegment.reloadCustomerSegment(state.bmc.current.id);
        },
      });
    },
    async reloadCustomerSegment(bmcId) {
      dispatch.customerSegment.fetchCustomerSegments(bmcId);
    },
  }),
};

export default customerSegment;
